<clr-main-container>
  <app-skip-link [focusElement]="contentRef.nativeElement"></app-skip-link>
  <clr-header class="header-6">
    <div class="branding">
      <a routerLink="/" class="logo-and-title">
        <span class="clr-icon clarity-logo"></span>
        <span class="title">{{ productTitle }}</span>
      </a>
    </div>
    <div class="divider"></div>
    <div class="header-nav" [clr-nav-level]="1">
      <a
        id="home-link"
        class="nav-link"
        routerLink="/"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        ><span class="nav-text">Home</span></a
      >
      <a
        class="nav-link"
        routerLink="/documentation"
        *ngIf="environment.latest == environment.version"
        routerLinkActive="active"
        ><span class="nav-text">Documentation</span></a
      >
      <a class="nav-link" [href]="getDocumentationUrl()" *ngIf="environment.latest !== environment.version"
        ><span class="nav-text">Documentation</span></a
      >
      <a class="nav-link" routerLink="/icons" routerLinkActive="active"><span class="nav-text">Icons</span></a>
      <a class="nav-link" routerLink="/community" routerLinkActive="active"><span class="nav-text">Community</span></a>
      <a class="nav-link" routerLink="/news" routerLinkActive="active"><span class="nav-text">What's New</span></a>
    </div>
  </clr-header>

  <router-outlet #content tabindex="-1"></router-outlet>
</clr-main-container>
